import { getRequest } from '../services/requestHandler';
import { Tour } from '../models';

export const getTours = async () => {
  const url = 'tour/getTours?activeOnly=true&useCache=false';
  const response = await getRequest<Tour>('getTours', url);
  return response;
};
